<div class="d-flex align-items-center gap-2 h-100 px-3">
  <div class="input-group">
    <input type="text" class="form-control form-control-sm" placeholder="Filter by league name" [(ngModel)]="filterText" (ngModelChange)="onFilterTextChanged($event)">
    <button class="btn btn-sm btn-outline-secondary border-opacity-50 d-flex gap-2 align-items-center" type="button">
      <fa-icon [fixedWidth]="true" [icon]="icon.filter"></fa-icon>
    </button>
  </div>
  <button *ngIf="isAdmin || isOgranizer" class="btn btn-sm btn-outline-primary d-flex gap-2 align-items-center text-nowrap" type="button" (click)="onNewLeaguePressed()">New League</button>
</div>